import sectionFaqVitalCss from '../css-snippets/section-faq-vital';

const html = `
<style>${sectionFaqVitalCss}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#ffffff"
  data-top-padding="true" data-bottom-padding="true" data-color="#000000" data-text-color="#000000"
  style="background-color: #ffffff; color: #000000; --color-text: #000000; --color-background: #ffffff; --btn-text-color: #ffffff; --btn-background-color: #214a88;">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="container">
      <div class="wrap-card">
        <div data-attribute="card-left" class="card-left" style="order: 1; --hl-background: #daecf0;" data-order="1">
          <div class="block-content-left">
            <div data-show="true" data-attribute="title-card-left" class="title-card-left">
              <h2>Frequently asked questions</h2>
              <p>Our local team are here to help.</p>
            </div>
            <div data-show="true" data-hl-background="#daecf0" data-attribute="hight-light-group"
              class="hight-light-group">
              <p>Chat with our customer support team, Monday-Friday. Or contact us via email at:</p>
              <p><a href="mailto:hello@simplynootropics.com">hello@simplynootropics.com</a></p>
            </div>
            <a data-show="true" data-color="#214a88" data-attribute="btn-card-left" class="btn-card-left" href="#"
              style="color: #214a88;">
              <span data-attribute="text-btn" class="text">SEE ALL FAQS</span>
              <span>
                <svg class="product-questions-action-lcon" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.5 10H17.5M17.5 10L12.5 5M17.5 10L12.5 15" stroke="currentColor" stroke-width="2.2"
                    stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
            </a>
          </div>
        </div>
        <div data-attribute="card-right" class="card-right" style="order: 2;" data-order="2">
          <div data-attribute="card-accordions" data-show-accordion="true" style="display: block;">
            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">What is collagen?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>
                    Collagen is a protein that makes up about one-third of the protein in our body. It keeps our skin
                    supple, hair shiny, nails strong, and joints moving freely. Collagen is also found in bones, teeth,
                    tendons, blood vessels, cartilage, and even our digestive tract. It is essential for maintaining the
                    strength and health of various tissues in the body.
                  </p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">What are collagen peptides?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>Collagen peptides are small, easily digestible pieces of collagen protein derived from hydrolysed
                    collagen. They support skin health, joint function, and overall vitality by providing essential
                    amino acids necessary for collagen production in the body.</p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">What is hydrolysed collagen, and how is it different from
                  regular collagen?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>
                    Hydrolysed collagen, also known as collagen peptides, is collagen that has been broken down into
                    smaller, more easily absorbed molecules through a process called hydrolysis. This makes it more
                    bioavailable, meaning your body can absorb and utilise it more effectively. The molecular weight of
                    collagen peptides affects their absorption. Peptides with a molecular weight under 5000 Da are
                    generally preferred for better bioavailability. When looking at a collagen supplement, less than
                    3,000 Da is optimal, and most brands sit between 2,500 Da and 5000 Da on the market. Ours is around
                    2,000Da for maximum absorption and efficacy.
                  </p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">What are the benefits of Type I, II, and III collagen?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p><span style="background-color:rgb(255,255,255);color:rgba(24,24,24,0.75);">Type I supports skin and
                      bones, Type II aids joint and cartilage health, and Type III maintains muscle, organ, and arterial
                      structure. This ensures holistic support for your body.</span></p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">Why do we use grass-fed collagen?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>Grass-fed collagen is superior because it comes from cattle raised on pastures, ensuring they are
                    fed a natural diet and treated humanely. This sustainable practice not only supports better animal
                    welfare but also reduces the environmental impact compared to grain-fed alternatives.</p>
                  <p>By choosing grass-fed sources, we prioritise quality, purity, and sustainability, delivering
                    collagen peptides that align with our values of ethical sourcing and environmental responsibility.
                  </p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">What is NR and how does it work?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>Nicotinamide Riboside (NR) is a form of vitamin B3 that acts as a powerful NAD+ booster. NR is a
                    precursor to NAD+ (nicotinamide adenine dinucleotide), a molecule essential for cellular energy
                    production, DNA repair, and overall cellular health. As we age, our NAD+ levels naturally decline,
                    contributing to a decrease in cellular function, energy, and resilience. NR helps to replenish these
                    levels, supporting energy, metabolism, and anti-aging benefits.</p>
                  <p>NR is converted into NAD+ in the body. This increase in NAD+ supports cellular processes linked to
                    energy production, cognitive function, and healthy aging.</p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">What makes the Simply Nootropics Vital Beauty formula
                  special?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>New answe<span style="background-color:rgb(255,255,255);color:rgba(24,24,24,0.75);">Beauty meets
                      vitality with Vital Beauty, the world’s first anti-aging collagen powder that combines premium
                      Collagen Peptides with Nicotinamide Riboside Chloride (NR) with 10 powerful ingredients for beauty
                      and longevity. Each serving includes 15g of hydrolysed collagen, along with NR (500mg), TMG,
                      Biotin, Keratin, Hyaluronic Acid, L-glutathione, Grape Seed Extract, Vitamin C, and Vitamin E.
                      This blend not only supports skin, hair, nails, bones, and joints but also boosts overall vitality
                      and health, making it the most comprehensive and value for money collagen drink available. And the
                      cherry on top? It tastes delicious too.</span>r</p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">Can hydrolysed collagen help with joint pain and arthritis?
                </div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p><span style="background-color:rgb(255,255,255);color:rgba(24,24,24,0.75);">Yes, hydrolysed collagen
                      can reduce joint discomfort by promoting collagen production and reducing inflammation, improving
                      mobility and overall joint health.</span></p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">How long does it take to see results from collagen
                  supplementation?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p><span style="background-color:rgb(255,255,255);color:rgba(24,24,24,0.75);">Results can vary, but
                      many users notice improvements in skin and joint health within 4-6 weeks, with some seeing
                      benefits in as little as 2-3 weeks.</span></p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">Is collagen safe for pregnant and nursing mothers?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p><span style="background-color:rgb(255,255,255);color:rgba(24,24,24,0.75);">Collagen and the
                      ingredients we use are generally safe for pregnant women, but consulting a healthcare provider is
                      always recommended. Our formula is designed to support overall health, including skin elasticity
                      and joint strength.</span></p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">What does Simply Nootropics collagen taste like?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>We spent nearly a year perfecting our flavours. We pride ourselves on having the most delicious and
                    refreshing collagen drinks on the market, with natural flavours that make health and wellness a
                    daily enjoyable experience. Not too sweet, not too bitter, just right.</p>
                  <p>Mango Passion: A delicious and refreshing tropical blend that combines the sweetness of mango with
                    the tangy notes of passionfruit. Perfect for a fruity boost to your daily routine.</p>
                  <p>Mixed Berry: A vibrant and juicy mix of berries that delivers a burst of flavour with every sip.
                    It's a crowd favourite for those who love the taste of fresh, ripe berries.</p>
                  <p>Unflavoured: For those who prefer a neutral option, our unflavoured collagen is incredibly
                    versatile. It can be easily added to your favourite drinks or foods without altering their taste.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
